import { FC } from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  Stack,
  Button,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  ModalFooter,
  Modal,
} from '@chakra-ui/react';
import { useDeleteDetailStore } from '../../../hooks';

export type Props = ReturnType<typeof useDeleteDetailStore>;

export const CrawlerDetailDeleteModalView: FC<Props> = ({
  crawlerDetail,
  isOpenModal,
  onCloseModal,
  onDeleteCrawlerDetail,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="xl"
    blockScrollOnMount
  >
    <ModalOverlay />
    <ModalContent>
      <ModalHeader p="40px">バージョンの削除</ModalHeader>
      <ModalCloseButton />
      <ModalBody px="40px">
        <Stack spacing="6" direction="column">
          <FormControl>
            <FormLabel>バージョン</FormLabel>
            <Input
              type="text"
              value={crawlerDetail?.version}
              width="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
        </Stack>
        <Text mt="60px" align="center" fontWeight="bold">
          上記のバージョンを削除しますか？
        </Text>
      </ModalBody>
      <ModalFooter gap="16px" justifyContent="center" p="40px">
        <Button
          w="140px"
          colorScheme="blackAlpha"
          variant="outline"
          onClick={onCloseModal}
        >
          キャンセル
        </Button>
        <Button colorScheme="red" w="140px" onClick={onDeleteCrawlerDetail}>
          削除
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
